import { secureStorage } from '../utils/secureStorage';
import { BACKEND_URL } from '../utils/backendUrl';
/**
 * Campaign API Client
 * Handles all API calls for Campaign management
 */

/**
 * Create a new campaign
 */
export const createCampaign = async (campaignData) => {
  const response = await fetch(`${BACKEND_URL}/api/v3/campaigns`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${secureStorage.getItem('nexus_access_token')}`
    },
    body: JSON.stringify(campaignData)
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to create campaign');
  }
  
  return response.json();
};

/**
 * Get campaign by ID
 */
export const getCampaign = async (campaignId) => {
  const response = await fetch(`${BACKEND_URL}/api/v3/campaigns/${campaignId}`, {
    headers: {
      'Authorization': `Bearer ${secureStorage.getItem('nexus_access_token')}`
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch campaign');
  }
  
  return response.json();
};

/**
 * List campaigns with filters
 */
export const listCampaigns = async (filters = {}) => {
  const params = new URLSearchParams();
  
  if (filters.status) params.append('status', filters.status);
  if (filters.product_id) params.append('product_id', filters.product_id);
  if (filters.group_id) params.append('group_id', filters.group_id);
  params.append('page', filters.page || 1);
  params.append('limit', filters.limit || 20);
  
  const response = await fetch(`${BACKEND_URL}/api/v3/campaigns?${params}`, {
    headers: {
      'Authorization': `Bearer ${secureStorage.getItem('nexus_access_token')}`
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to list campaigns');
  }
  
  return response.json();
};

/**
 * Update campaign
 */
export const updateCampaign = async (campaignId, updateData) => {
  const response = await fetch(`${BACKEND_URL}/api/v3/campaigns/${campaignId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${secureStorage.getItem('nexus_access_token')}`
    },
    body: JSON.stringify(updateData)
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to update campaign');
  }
  
  return response.json();
};

/**
 * Archive campaign
 */
export const archiveCampaign = async (campaignId) => {
  const response = await fetch(`${BACKEND_URL}/api/v3/campaigns/${campaignId}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${secureStorage.getItem('nexus_access_token')}`
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to archive campaign');
  }
  
  return response.json();
};

/**
 * Assign team to campaign
 */
export const assignTeamToCampaign = async (campaignId, groupId) => {
  const response = await fetch(`${BACKEND_URL}/api/v3/campaigns/${campaignId}/assign-team?group_id=${groupId}`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${secureStorage.getItem('nexus_access_token')}`
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to assign team');
  }
  
  return response.json();
};

/**
 * Remove team from campaign
 */
export const removeTeamFromCampaign = async (campaignId, groupId) => {
  const response = await fetch(`${BACKEND_URL}/api/v3/campaigns/${campaignId}/assignments/${groupId}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${secureStorage.getItem('nexus_access_token')}`
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to remove team');
  }
  
  return response.json();
};

/**
 * Get user's active campaigns
 */
export const getUserCampaigns = async (userId) => {
  const response = await fetch(`${BACKEND_URL}/api/v3/campaigns/users/${userId}/campaigns`, {
    headers: {
      'Authorization': `Bearer ${secureStorage.getItem('nexus_access_token')}`
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch user campaigns');
  }
  
  return response.json();
};
